import React, { ButtonHTMLAttributes } from "react";
import { Container } from "./style";

type formButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const FormButton: React.FC<formButtonProps> = ({ children, ...rest }) => {
  return (
    <Container type="button" {...rest}>
      {children}
    </Container>
  );
};

export default FormButton;
